import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import AuthLayout from "@/pages/auth/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters");
    if (pw !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/accept-invite", { token, new_password: pw });
      toast.success("Account activated. Please sign in.");
      navigate("/login");
    } catch (e) {
      setError(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout title="Invalid invitation" subtitle="This invitation link is missing or invalid.">
        <Link to="/login" className="text-sm font-semibold text-teal hover:underline">Go to sign in</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Welcome to Medoho Sales OS" subtitle="Set your password to activate your account.">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="pw">Create password</Label>
          <Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 h-12" data-testid="invite-password-input" autoFocus />
        </div>
        <div>
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-12" data-testid="invite-confirm-input" />
        </div>
        {error && <p className="text-sm text-rose-600">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-12 bg-teal hover:bg-teal-700" data-testid="invite-submit-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Activate account"}
        </Button>
      </form>
    </AuthLayout>
  );
}
